import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getWaitingUsersApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction( data,
 apiConstants.USER.GET_WAITING_USER
    
 
    )
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
